angular.module('picmonicng').factory('StudySchedulerModal', [
  '$modal',

  function ($modal) {
    return {
      show: function (ctrl, existingStudyPlan, playlist, studyPlans) {
        return $modal.open({
          templateUrl: '/templates/app/factories/study-scheduler-modal/study-scheduler-modal.html',
          windowClass: 'study-scheduler-modal full-screen-modal',
          backdropClass: 'above-nav',
          backdrop: 'static',
          size: 'lg',
          controller: [
            '$scope',
            'UserService',
            'studyplansResource',
            '$rootScope',
            function ($scope, UserService, studyplansResource, $rootScope) {
              $scope.UserService = UserService;
              $scope.isV2 = $rootScope.bodyClass.includes('v2-nav');

              $scope.currentStep = 0;
              $scope.steps = [
                {
                  step: 0,
                  name: 'intro',
                  pro_tip: 'You can always create a study plan from your home screen.',
                  img: '/assets/img/modals/study-scheduler/eye-guy-pointer.png',
                  img_width: 144,
                  img_height: 209,
                },
                {
                  step: 1,
                  name: 'date-of-test',
                  pro_tip: '',
                  img: '/assets/img/modals/study-scheduler/eye-guy-exam.png',
                  img_width: 196,
                  img_height: 232,
                },
                {
                  step: 2,
                  name: 'days-of-week',
                  pro_tip: '',
                  img: '/assets/img/modals/study-scheduler/eye-guy-calendar.png',
                  img_width: 196,
                  img_height: 189,
                },
                {
                  step: 3,
                  name: 'track-select',
                  pro_tip: '',
                  img: '/assets/img/modals/study-scheduler/eye-guy-subjects.png',
                  img_width: 181,
                  img_height: 214,
                },
                {
                  step: 4,
                  name: 'plan-overview',
                  pro_tip: '',
                  img: '/assets/img/modals/study-scheduler/eye-guy-yay.png',
                  img_width: 207,
                  img_height: 298,
                },
                {
                  step: 5,
                  name: 'track-select',
                  pro_tip: '',
                  img: '/assets/img/modals/study-scheduler/eye-guy-calendar.png',
                  img_width: 196,
                  img_height: 189,
                },
              ];

              // preload eye-guy images
              for (i = 0; i < $scope.steps.length; i++) {
                img = new Image();
                img.src = $scope.steps[i].img;
              }

              $scope.trackSelector = {
                track_ids: [],
                playlist_ids: [],
                excluded_card_ids: [],
                pathway_ids: [],
              };
              $scope.testDate = null;

              $scope.plan = {
                studyplan_id: null,
                user_id: UserService.user.user_id,
                test_date: null,
                days_per_week: 3,
                days_of_week: '1010100',
                name: '',
                phone: '',
                sms_optin: 0,
                track_ids: [],
                playlist_ids: [],
                excluded_card_ids: [],
                total_seconds_per_day: 0,
              };

              if (existingStudyPlan) {
                // Merge existing plan
                for (var k in $scope.plan) {
                  if (!existingStudyPlan.hasOwnProperty(k)) {
                    continue;
                  }

                  // Handle string to array conversion
                  if (Array.isArray($scope.plan[k])) {
                    $scope.plan[k] =
                      existingStudyPlan[k] === ''
                        ? []
                        : existingStudyPlan[k].split(',').map(function (val) {
                            return parseInt(val, 10);
                          });
                    $scope.trackSelector[k] = $scope.plan[k].slice();
                  } else {
                    $scope.plan[k] = existingStudyPlan[k];
                  }
                }

                $scope.existingPlan = Object.assign({}, $scope.plan);
                $scope.currentStep = 1;
                $scope.testDate = moment.unix($scope.plan.test_date);

                studyplansResource.pathways({ studyplan_id: $scope.plan.studyplan_id }, function (result) {
                  $scope.trackSelector.pathway_ids = result;
                });
              }

              // skip to step 1 if you've created a study schedule in the past
              if (studyPlans && studyPlans.length > 0) {
                $scope.currentStep = 1;
                $scope.existingStudyPlansTotal = studyPlans.length;
              }

              // used when launching via the playlist more menu "Create Study Plan"
              // to automatically select the playlist
              if (playlist) {
                $scope.trackSelector.playlist_ids.push(playlist.playlist_id);
              }

              $scope.amountOfDaysPerWeek = [];
              $scope.minDate = new Date(Date.now() + 60 * 60 * 24 * 1000);

              $scope.validateTestDate = function () {
                if (!$scope.testDate) {
                  return;
                }

                var today = moment().hour(0).minutes(0).seconds(0);
                var testDate = moment($scope.testDate).add(1, 'second');
                $scope.daysUntilTest = testDate.diff(today, 'days');

                if ($scope.daysUntilTest < 1) {
                  return;
                }

                $scope.maxDaysPerWeek = Math.min($scope.daysUntilTest, 7);
                $scope.plan.days_per_week =
                  existingStudyPlan && $scope.plan.days_per_week <= $scope.maxDaysPerWeek
                    ? $scope.plan.days_per_week
                    : Math.min($scope.maxDaysPerWeek, 3);

                $scope.amountOfDaysPerWeek = [];
                for (var i = 1; i < $scope.maxDaysPerWeek + 1; i++) {
                  $scope.amountOfDaysPerWeek.push(i);
                }

                $scope.nextStep();
              };

              $scope.validateDaysPerWeek = function () {
                $scope.getEstimate();
                $scope.nextStep();
              };

              $scope.setPlanTestDate = function () {
                $scope.plan.test_date = moment($scope.testDate).format('X');

                if ($scope.plan.name === '' || $scope.plan.name.indexOf('Study Plan for ') === 0) {
                  $scope.plan.name = 'Study Schedule for ' + moment($scope.testDate).format('M/D') + ' Test ';
                }
              };

              $scope.validateTracks = function () {
                if (!$scope.trackSelector.track_ids.length && !$scope.trackSelector.playlist_ids.length) {
                  return;
                }

                $scope.nextStep();
              };

              $scope.getEstimate = function () {
                $scope.estimate = {};
                $scope.plan.total_seconds_per_day = 0;

                if (!$scope.trackSelector.track_ids.length && !$scope.trackSelector.playlist_ids.length) {
                  return;
                }

                $scope.loadingEstimate = true;

                $scope.plan.track_ids = $scope.trackSelector.track_ids;
                $scope.plan.playlist_ids = $scope.trackSelector.playlist_ids;
                $scope.plan.excluded_card_ids = $scope.trackSelector.excluded_card_ids;

                studyplansResource.estimate(
                  $scope.plan,
                  function (estimate) {
                    $scope.estimate = estimate;
                    $scope.plan.total_seconds_per_day = estimate.per_day.total_seconds;
                    $scope.loadingEstimate = false;
                  },
                  function () {
                    $scope.loadingEstimate = false;
                  }
                );
              };

              $scope.checkName = function () {
                if (!$scope.plan.name) {
                  return;
                }

                $scope.orderTracks();
              };

              $scope.orderTracks = function () {
                $scope.loadingOrder = true;
                studyplansResource.ordered_list(
                  $scope.plan,
                  function (ordered_list) {
                    $scope.ordered_list = ordered_list;

                    if ($scope.ordered_list.length === 1) {
                      $scope.saveStudyplan();
                    } else {
                      $scope.nextStep(5);
                      $scope.loadingOrder = false;
                    }
                  },
                  function () {
                    console.error('Error occurred while ordering tracks');
                    $scope.loadingOrder = false;
                  }
                );
              };

              $scope.saveStudyplan = function () {
                if ($scope.saving) {
                  return;
                }

                $scope.plan.ordered_list = $scope.ordered_list;
                $scope.saving = true;

                studyplansResource.savePlan(
                  $scope.plan,
                  function (studyPlan) {
                    $scope.saving = false;

                    UserService.user.settings.active_studyplan = studyPlan.studyplan_id;
                    UserService.user.$update();

                    // ghetto refresh fix later
                    if (ctrl) {
                      ctrl.getStudyPlans();
                    }

                    $scope.loadingOrder = false;
                    atlasEvent('click', 'study scheduler - modal - complete');
                    $scope.$close();
                  },
                  function () {
                    $scope.saving = false;
                  }
                );
              };

              $scope.moveTop = function (track) {
                var t = $scope.ordered_list.splice($scope.ordered_list.indexOf(track), 1);
                $scope.ordered_list.unshift(t[0]);
              };
              $scope.moveBottom = function (track) {
                var t = $scope.ordered_list.splice($scope.ordered_list.indexOf(track), 1);
                $scope.ordered_list.push(t[0]);
              };

              $scope.nextStep = function (override) {
                $scope.currentStep = override ? override : $scope.currentStep + 1;

                if ($scope.currentStep > $scope.steps.length - 1) {
                  $scope.currentStep = $scope.steps.length - 1;
                }

                atlasEvent('click', 'study scheduler - modal - next step ' + $scope.currentStep);
              };

              $scope.previousStep = function (override) {
                $scope.currentStep = override ? override : $scope.currentStep - 1;

                if ($scope.currentStep < 0) {
                  $scope.currentStep = 0;
                }

                atlasEvent('click', 'study scheduler - modal - previous step ' + $scope.currentStep);
              };

              $scope.close = function () {
                atlasEvent('click', 'study scheduler - modal - close step ' + $scope.currentStep);
                $scope.$close();
              };

              atlasEvent('click', 'study scheduler - modal - launch');
            },
          ],
        });
      },
    };
  },
]);
